import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import "../styles/Auth.css";
import { useAuth } from "../auth/AuthContext";
import api from "../api/axios";

export default function Sesion() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Estado para el modal de recuperación
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetMsg, setResetMsg] = useState("");
  const [resetError, setResetError] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const email = e.target.email.value.trim();
    const password = e.target.password.value;
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(err.message || "Error inesperado");
    } finally {
      setLoading(false);
    }
  };

  const onResetSubmit = async (e) => {
    e.preventDefault();
    setResetError("");
    setResetMsg("");
    setResetLoading(true);
    try {
      await api.post("/auth/password-reset/", { email: resetEmail });
      setResetMsg("Si ese email existe, recibirás un correo en breve.");
    } catch (err) {
      setResetError("Error al enviar. Inténtalo de nuevo.");
    } finally {
      setResetLoading(false);
    }
  };

  const GOOGLE_OAUTH_URL =
    process.env.REACT_APP_API_BASE
      ? `${process.env.REACT_APP_API_BASE}/auth/google`
      : "https://api.m3campus.com/auth/google";

  return (
    <div className="auth">
      <div className="auth__card">
        <h2>Iniciar sesión</h2>
        <p className="auth__muted">Accede con tu correo (Antes crear cuenta en link abajo) o con Google directamente.</p>

        {error && <div className="auth__error">{error}</div>}

        <form onSubmit={onSubmit} className="auth__form">
          <label>
            Correo
            <input name="email" type="email" placeholder="tuemail@dominio.com" required />
          </label>

          <label>
            Contraseña
            <input name="password" type="password" placeholder="••••••••" required />
          </label>

          {/* ← enlace de recuperación */}
          <div style={{ textAlign: "right", marginTop: -8, marginBottom: 8 }}>
            <button
              type="button"
              onClick={() => { setShowReset(true); setResetEmail(""); setResetMsg(""); setResetError(""); }}
              style={{ background: "none", border: "none", color: "#224ad9", cursor: "pointer", fontSize: 13, padding: 0 }}
            >
              ¿Olvidaste tu contraseña?
            </button>
          </div>

          <button className="auth__primary" type="submit" disabled={loading}>
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <div className="auth__divider"><span>o</span></div>

        <a className="auth__googleBtn" href={GOOGLE_OAUTH_URL}>
          <GoogleIcon />
          Continuar con Google
        </a>

        <div className="auth__footer">
          <span>¿No tienes cuenta?</span>
          <Link to="/registro">Crear cuenta</Link>
        </div>
      </div>

      {/* Modal recuperación de contraseña */}
      {showReset && (
        <div
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 2000, padding: 16
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowReset(false); }}
        >
          <div style={{
            background: "white", borderRadius: 16, padding: 32,
            width: "100%", maxWidth: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.2)"
          }}>
            <h3 style={{ marginTop: 0, marginBottom: 8 }}>Recuperar contraseña</h3>
            <p style={{ color: "#666", fontSize: 14, marginBottom: 20 }}>
              Introduce tu email y te enviaremos un enlace para crear una nueva contraseña.
            </p>

            {resetMsg ? (
              <div style={{ color: "green", fontSize: 14, marginBottom: 16 }}>{resetMsg}</div>
            ) : (
              <form onSubmit={onResetSubmit}>
                {resetError && (
                  <div style={{ color: "red", fontSize: 13, marginBottom: 12 }}>{resetError}</div>
                )}
                <input
                  type="email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  placeholder="tuemail@dominio.com"
                  required
                  style={{
                    width: "100%", padding: "10px 12px", borderRadius: 10,
                    border: "1px solid rgba(0,0,0,0.15)", fontSize: 14,
                    marginBottom: 12, boxSizing: "border-box"
                  }}
                />
                <button
                  type="submit"
                  disabled={resetLoading}
                  style={{
                    width: "100%", padding: "11px", borderRadius: 10,
                    background: "#224ad9", color: "white", border: "none",
                    fontWeight: 700, fontSize: 14, cursor: "pointer"
                  }}
                >
                  {resetLoading ? "Enviando..." : "Enviar enlace"}
                </button>
              </form>
            )}

            <button
              onClick={() => setShowReset(false)}
              style={{
                marginTop: 16, width: "100%", padding: "10px", borderRadius: 10,
                background: "transparent", border: "1px solid rgba(0,0,0,0.12)",
                cursor: "pointer", fontSize: 14, color: "#444"
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.655 32.659 29.236 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.045 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917Z" />
      <path fill="#FF3D00" d="M6.306 14.691 12.89 19.52C14.67 16.109 18.062 14 24 14c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.045 6.053 29.268 4 24 4c-7.682 0-14.39 4.337-17.694 10.691Z" />
      <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.197l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.215 0-9.623-3.318-11.288-7.946l-6.54 5.037C9.438 39.556 16.227 44 24 44Z" />
      <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a11.97 11.97 0 0 1-4.084 5.565l.003-.002 6.19 5.238C36.973 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917Z" />
    </svg>
  );
}

}